export default {
  setFingerPrint(state, value) {
    state.fingerPrint = value
  },
  setFingerPrintsForEmployers(state, value) {
    state.fingerPrintsForEmployers = value
  },
  setActiveListFingerprint(state, value) {
    state.activeListFingerprint = value
  },
}
